import Button from "../../../../../ui/button";
import { useDataEstimateContext } from "../../../hooks/useModalContex";
import ModalRedirectToPageWizardSell from "../../modals/modalRedirectToPageWizardSell";
import ModalRansom from "../../modals/modalRansom";
import ModalRedirectToPageWizardTradeIn from "../../modals/modalRedirectToPageWizardTradeIn";
import useOpenModal from "../../../../../ui/modal/hooks/useOpenModal";

import style from "../styles.module.scss";

interface ISellEstimateProps {
  isSecondary: boolean;
}

const SellEstimate = ({ isSecondary }: ISellEstimateProps) => {
  const { dataModal } = useDataEstimateContext();
  const {
    open: openRansom,
    offsetY: offsetYRansom,
    handleChangeModal: handleChangeModalRansom,
  } = useOpenModal();

  const {
    open: openSell,
    offsetY: offsetYSell,
    handleChangeModal: handleChangeModalSell,
  } = useOpenModal();

  const {
    open: openTradeIn,
    offsetY: offsetYTradeIn,
    handleChangeModal: handleChangeModalTradeIn,
  } = useOpenModal();

  return (
    <div className={style.sell}>
      <div className={style.sell__container}>
        <div className={style.sell__offer}>
          <div className={style.sell__text}>
            <p>
              Мы готовы предложить вам быструю сделку по цене ниже рыночной
              стоимости:
            </p>
          </div>

          <div className={style.sell__buttons}>
            <Button
              label="Продать с экспертом"
              onClick={(event) => handleChangeModalSell(true)}
            />
            <Button
              label="Продать в ТРЕЙД-ИН"
              onClick={(event) => handleChangeModalTradeIn(true)}
              variant="dark"
            />
          </div>

          {/* {isSecondary && (
            <div className={style.sell__helpButton}>
              <Button
                label="Помощь в продаже"
                variant="dark"
                onClick={handleClickSell}
              />
            </div>
          )} */}
        </div>

        {isSecondary && (
          <ModalRedirectToPageWizardSell
            isOpen={openSell}
            onDismiss={(value) => handleChangeModalSell(value, 0)}
            data={dataModal}
            offsetY={offsetYSell}
          />
        )}

        <ModalRedirectToPageWizardTradeIn
          isOpen={openTradeIn}
          onDismiss={(value) => handleChangeModalTradeIn(value)}
          offsetY={offsetYTradeIn}
        />

        {/* {dataModal && (
          <ModalRansom
            isOpen={openRansom}
            onDismiss={(value) => handleChangeModalRansom(value)}
            data={dataModal}
            offsetY={offsetYRansom}
          />
        )} */}

        {/* <div className={style.sell__accompanimentReit}>
          <AccompanimentReitEstimate />
        </div> */}
      </div>
    </div>
  );
};

export default SellEstimate;
